import { Brand } from "@/types/brand";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const BrandsMobile = ({ brandsData }: { brandsData: Brand[] }) => {
  return (
    <Swiper
      modules={[Navigation, Pagination]}
      spaceBetween={30}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      className="brands-swiper"
    >
      {brandsData.map((brand, index) => (
        <SwiperSlide
          key={brand.id}
          style={index === 2 ? { marginLeft: '100px' } : {}}
        >
          <div className="flex h-full items-center justify-center">
            <SingleBrand brand={brand} />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default BrandsMobile;

const SingleBrand = ({ brand }: { brand: Brand }) => {
  const { href, image, imageLight, name } = brand;

  // Custom dimensions for different logos
  let dimensions = "h-24 w-64"; // Default for Akamai
  if (name === "CME Group") {
    dimensions = "h-40 w-[600px]"; // Much larger for CME
  } else if (name === "BpiFrance") {
    dimensions = "h-40 w-96"; // Larger for BPI
  }

  return (
    <div className="flex items-center justify-center mx-auto">
      <a
        href={href}
        target="_blank"
        rel="nofollow noreferrer"
        className={`relative ${dimensions} transition hover:opacity-75`}
      >
        {imageLight && (
          <Image 
            src={imageLight} 
            alt={name} 
            fill 
            className="hidden object-contain dark:block" 
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            priority
          />
        )}
        <Image 
          src={image} 
          alt={name} 
          fill 
          className="block object-contain dark:hidden" 
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          priority
        />
      </a>
    </div>
  );
}; 